import {z} from 'zod'

import {CreateOrUpdateBlockBannerDocument} from '@sdox/api'

import {buttonSchema} from '../../utils/schemas'
import {createMetaSchema} from '../../utils/getCreateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'
import {buttonFormToInput} from '../../utils/buttonMappers'

import type {BlockBannerInput, CreateOrUpdateBlockBannerMutation} from '@sdox/api'

type CreateBannerValidatorSchema = z.infer<typeof createBannerValidatorSchema>

const createBannerValidatorSchema = z.object({
  data: z.object({
    title: z.string().min(1),
    cta: buttonSchema,
    image: z.object({
      fileHash: z.string().min(1),
    }),
  }),
  meta: createMetaSchema,
})

export const bannerConfig = createFormConfig<
  CreateBannerValidatorSchema,
  CreateOrUpdateBlockBannerMutation,
  BlockBannerInput
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockBannerDocument,
  },
  fieldMapper: ({data}) => ({
    cta: buttonFormToInput(data.cta),
    title: data.title,
    fileHash: data.image.fileHash,
  }),
  validatorSchema: createBannerValidatorSchema,
  inputFields: [
    {
      label: 'Image',
      fieldName: 'data.image',
      inputType: 'image',
      defaultValue: '',
      required: true,
    },
    {
      label: 'Title',
      fieldName: 'data.title',
      inputType: 'text',
      defaultValue: '',
      required: true,
    },
    {
      label: 'Button Config',
      fieldName: 'divider',
      inputType: 'sectionDivider',
      defaultValue: '',
    },
    {
      label: 'Button',
      fieldName: 'data.cta',
      inputType: 'button',
      defaultValue: '',
      required: true,
    },
  ],
})
